var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaccineRoundedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.62,
    cy: 10.6273,
    r: 10.62,
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7024 2.70989L19.294 4.30895L16.9672 6.64697L15.3756 5.04791L17.7024 2.70989ZM18.3161 4.30895L17.7024 3.69286L16.3517 5.04964L16.9655 5.66573L18.3161 4.30895Z",
    fill: "#572580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0052 3.69432L18.3133 7.01877L7.89483 17.4854L4.5867 14.1609L15.0052 3.69432ZM17.3355 7.01877L15.0052 4.67729L5.56458 14.1609L7.89483 16.5041L17.3355 7.01877Z",
    fill: "#572580"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10301 18.9302L5.10625 15.9121L4.61419 15.4243L1.61095 18.4424L2.10301 18.9302Z",
    fill: "#572580"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63663 20.468L6.63864 17.4512L6.14658 16.9634L3.14457 19.9802L3.63663 20.468Z",
    fill: "#572580"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48179 13.2696L3.9742 13.7559L3.51994 14.2127L8.08854 18.804L7.59787 19.292L2.54207 14.2145L3.48179 13.2696Z",
    fill: "#572580"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91378 22.0001L5.40584 21.5123L0.595535 16.6782L0.103478 17.1661L4.91378 22.0001Z",
    fill: "#572580"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1734 3.32289L21.9946 0.487793L21.5026 -2.27033e-05L18.6814 2.83507L19.1734 3.32289Z",
    fill: "#572580"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56204 14.5922L8.05397 14.1045L6.76283 12.807L6.2709 13.2947L7.56204 14.5922Z",
    fill: "#572580"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29364 12.8506L8.78544 12.3628L7.99611 11.57L7.50431 12.0579L8.29364 12.8506Z",
    fill: "#572580"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52192 11.6099L10.0142 11.1226L9.22566 10.329L8.73338 10.8164L9.52192 11.6099Z",
    fill: "#572580"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2565 10.8787L11.7486 10.3911L10.4588 9.09465L9.96681 9.58227L11.2565 10.8787Z",
    fill: "#572580"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9872 9.13815L12.4791 8.65039L11.6899 7.85751L11.198 8.34527L11.9872 9.13815Z",
    fill: "#572580"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2182 7.89827L13.7102 7.41064L12.9212 6.61754L12.4292 7.10517L13.2182 7.89827Z",
    fill: "#572580"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9528 7.1685L15.4445 6.68066L14.153 5.38351L13.6612 5.87135L14.9528 7.1685Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccineRoundedIcon);
export default __webpack_public_path__ + "static/media/vaccine_rounded_icon.501a7bc82f106d3b37aace9f246ede2a.svg";
export { ForwardRef as ReactComponent };